module.exports = __webpack_public_path__ + "img/18.a8a2fe44.png";